import React from "react";
import PropTypes from "prop-types";
import { Button } from "bootstrap-4-react/lib/components";

/**
 * Walmart step — placeholder for v1. The Walmart adapter is not yet wired
 * in walmart-service; the UI scaffolding is in place so when it lands,
 * only this file changes (mirror EbayStep's shape).
 */
export default function WalmartStep({ onSkip }) {
    return (
        <div className="alert alert-info">
            <strong>Walmart push — coming soon.</strong>
            <p className="mb-2 mt-2">
                Pushing inventory to Walmart isn&apos;t available yet. Skip this step
                to finish; your eBay listing has already been published.
            </p>
            <Button className="cus-primary-transparent-btn" onClick={onSkip}>
                Skip Walmart
            </Button>
        </div>
    );
}

WalmartStep.propTypes = {
    onSkip: PropTypes.func.isRequired,
};
